import { useSearchParams } from "react-router-dom";
import LeadForm from "@/components/LeadForm";
import SEO from "@/components/SEO";
import { Ruler, Users, Settings2, Target, ArrowRight } from "lucide-react";

const PRUEF_CARDS = [
  {
    icon: Ruler,
    title: "Fläche",
    text: "Wie viel nutzbare Fläche ist vorhanden? Gibt es Hindernisse, Pfeiler, Nebenräume oder besondere Wege?",
  },
  {
    icon: Users,
    title: "Zielgruppe",
    text: "Geht es um Familien, Hotelgäste, Firmen, Events, Competition, Tourismus oder digitale Besucher?",
  },
  {
    icon: Settings2,
    title: "Betrieb",
    text: "Wer betreut das Erlebnis? Wie werden Einweisung, Buchung, Ablauf und Support organisiert?",
  },
  {
    icon: Target,
    title: "Systemfit",
    text: "Welches Profil passt grundsätzlich: PVRA, AR_ENA, PINE VR, Hotel VR oder PINE Places?",
  },
  {
    icon: ArrowRight,
    title: "Nächster Schritt",
    text: "Nach der Anfrage folgt keine automatische Kaufempfehlung, sondern ein strukturiertes Gespräch.",
  },
];

export default function StandortPruefen() {
  const [params] = useSearchParams();
  const preselect = params.get("system") || "";
  return (
    <>
      <SEO
        title="Standortpotenzial prüfen – Welches PINE Systems Profil passt?"
        description="Prüfen Sie, welches PINE Systems Profil zu Ihrer Fläche, Zielgruppe, Betreiberlogik und Customer Journey passt."
      />
      <section className="relative border-b border-[rgba(255,255,255,0.08)] overflow-hidden">
        <div className="absolute inset-0 grid-overlay opacity-30" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-12 md:pt-36 md:pb-20">
          <div className="overline">Standort prüfen</div>
          <h1 className="font-display text-4xl md:text-6xl uppercase mt-4 max-w-4xl leading-[1.05]">
            Welches System passt zu <br />
            <span className="text-[#18E096]">Ihrem Standort?</span>
          </h1>
          <p className="text-[#AEB7B7] mt-6 max-w-3xl text-base md:text-lg leading-relaxed">
            Der passende Produktfit entsteht nicht durch Quadratmeter allein. Entscheidend sind
            Fläche, Raumlogik, Gästewege, Personal, Zielgruppe, Infrastruktur, Betrieb und
            Customer Journey.
          </p>
        </div>
      </section>

      {/* Warum wir zuerst prüfen */}
      <section className="border-b border-[rgba(255,255,255,0.08)] bg-[#0B0F10]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
          <div className="overline mb-4">Vorgehen</div>
          <h2 className="font-display text-3xl md:text-5xl uppercase leading-[1.05] max-w-4xl">
            Warum wir zuerst <span className="text-[#18E096]">prüfen.</span>
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8 max-w-5xl">
            <p className="text-[#AEB7B7] text-base md:text-lg leading-relaxed">
              Ein PINE Systems Produkt soll zu Ihrem Standort passen. Deshalb beginnt der Prozess
              nicht mit einem Standardpaket, sondern mit einer strukturierten Einschätzung.
            </p>
            <p className="text-[#AEB7B7] text-base md:text-lg leading-relaxed">
              Wir betrachten nicht nur Quadratmeter. Wir betrachten Fläche, Raumhöhe, Grundriss,
              Gästewege, Zielgruppe, Betreiberstruktur, Personal, Infrastruktur, aktuelle Nutzung,
              Customer Journey und gewünschtes Erlebnisprofil.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px mt-12 border-l border-t border-[rgba(255,255,255,0.08)]">
            {PRUEF_CARDS.map((c, i) => {
              const Icon = c.icon;
              return (
                <div
                  key={i}
                  className="border-r border-b border-[rgba(255,255,255,0.08)] p-6 bg-[#0B0F10] hover:bg-[#141819] transition-colors"
                  data-testid={`pruef-card-${i}`}
                >
                  <Icon size={22} strokeWidth={1.25} className="text-[#18E096]" />
                  <div className="font-display text-base md:text-lg uppercase mt-4">{c.title}</div>
                  <p className="text-[#AEB7B7] text-sm mt-3 leading-relaxed">{c.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-20">
          <p className="text-[#AEB7B7] text-sm md:text-base mb-6">
            Je genauer Ihre Angaben sind, desto besser können wir den ersten Produktfit
            einschätzen.
          </p>
          <LeadForm sourcePage="standort-pruefen" preselectInterest={preselect} />
        </div>
      </section>
    </>
  );
}
